"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _price = require("./price.styled");

var _const = require("./const");

var _usePrice2 = require("./use-price");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Price = function Price(_ref) {
  var priceRange = _ref.priceRange;

  var _usePrice = (0, _usePrice2.usePrice)({
    priceRange: priceRange
  }),
      regularPrice = _usePrice.regularPrice,
      salePrice = _usePrice.salePrice,
      isSalePrice = _usePrice.isSalePrice,
      memberPriceValue = _usePrice.memberPriceValue,
      memberPrice = _usePrice.memberPrice,
      plpMemberPrice = _usePrice.plpMemberPrice;

  var regularPriceContent = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_price.PriceTextRegularStyled, null, " ", _const.PriceText.REGULAR, " "), " ", /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_price.PriceRegularStyled, null, regularPrice));

  var salePriceContent = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_price.PriceTextOldStyled, null, " ", _const.PriceText.REGULAR, " "), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_price.PriceOldStyled, null, regularPrice), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_price.PriceSaleStyled, null, /*#__PURE__*/_react.default.createElement(_price.PriceTextFinalStyled, null, " ", _const.PriceText.SALE, " "), " ", /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_price.PriceFinalStyled, null, salePrice)));

  var memberPriceContent = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_price.PriceMemberStyled, null, _const.PriceText.DIAMOND_MEMBER), /*#__PURE__*/_react.default.createElement(_price.PriceMemberAmountStyled, null, memberPriceValue > 0 && isSalePrice ? plpMemberPrice : memberPrice));

  var priceContent = isSalePrice ? salePriceContent : regularPriceContent;
  var sale = memberPriceValue > 0 && isSalePrice ? /*#__PURE__*/_react.default.createElement(_price.MemberAndSale, null, priceContent, " ", memberPriceContent) : memberPriceValue > 0 && !isSalePrice ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, priceContent, " ", /*#__PURE__*/_react.default.createElement("br", null), " ", memberPriceContent) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, priceContent);
  return sale;
};

var _default = Price;
exports.default = _default;